import BaseModelAPI from '../BaseModelAPI';

export default class ControlCardLog extends BaseModelAPI {
	static entity = 'controlcardlog';
	static entityName = 'controlcardlog';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.controlCardId = '';
			this.controlCard = {};
			this.transactionType = '';
			this.transaction = '';
			this.qtyBefore = 0;
			this.qtyAfter = 0;
			this.areaBeforeId = '';
			this.areaBefore = {};
			this.areaAfterId = '';
			this.areaAfter = {};
			this.rackBeforeId = '';
			this.rackBefore = {};
			this.rackAfterId = '';
			this.rackAfter = {};
			this.controlCardStatusId = '';
			this.controlCardStatus = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}